module.exports = __webpack_public_path__ + "img/design.3bf3c7f9.svg";